import { useEffect, useState } from 'react';

import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { SelectChangeEvent } from '@mui/material';

import {
  FilterFieldContainer,
  FilterLabel,
  FilterMenuItem,
  FilterSelect,
  selectMenuPaperSx,
} from '../GeneratikTableFilterPanel.styles';
import { SelectFieldProps } from '../GeneratikTableFilterPanel.types';

const SelectFilterField = ({ field, value, onChange, t, disabled, autoOpen }: SelectFieldProps) => {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    if (!autoOpen) return;
    const timer = setTimeout(() => setIsOpen(true), 300);
    return () => clearTimeout(timer);
  }, [autoOpen]);

  const sortedOptions = (field.options || [])
    .slice()
    .sort((a, b) => (a.label ?? '').localeCompare(b.label ?? ''));

  return (
    <FilterFieldContainer>
      <FilterLabel>{field.label}</FilterLabel>
      <FilterSelect
        value={value}
        onChange={(e: SelectChangeEvent<unknown>) => onChange(e.target.value as string)}
        displayEmpty
        IconComponent={KeyboardArrowDownIcon}
        open={isOpen}
        onOpen={() => setIsOpen(true)}
        onClose={() => setIsOpen(false)}
        MenuProps={{ PaperProps: { sx: selectMenuPaperSx } }}
        disabled={disabled}
        data-testid={`filter-field-${field.id}`}
      >
        <FilterMenuItem key="empty" value="">
          {field.placeholder || String(t('Optional'))}
        </FilterMenuItem>
        {sortedOptions.map((option) => (
          <FilterMenuItem key={option.value} value={option.value}>
            {option.label}
          </FilterMenuItem>
        ))}
      </FilterSelect>
    </FilterFieldContainer>
  );
};

export default SelectFilterField;
